/**
 * 工单设置
 */
import { WORKORDERCONFIG } from '../types';

export default {
    name: `${WORKORDERCONFIG}`,
    path: '/workOrderConfig',
    component: () => import(/* webpackChunkName: 'workOrderConfig' */ '@/views/workOrderConfig/'),
    redirect: { name: `${WORKORDERCONFIG}Index` },
    meta: {
        title: '工单设置',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${WORKORDERCONFIG}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'workOrderConfig' */ '@/views/workOrderConfig/home/Home.vue'),
        },
    ],
};
